<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="fill-height">
    <TermsDialog v-model="showTermsModal" />
    <!-- v-if="user.profileComplete && hasClient && user.status == 'ACTIVE'" -->
      <v-navigation-drawer
        app
        :class="{
          'custom-navigation-drawer': true,
          'remove-menu-desk': !user.profileComplete && !hasClient && user.status != 'ACTIVE'
        }"
        clipped
        v-model="drawer"
        :stateless="showingTour"
        :style="{'width': menuWidth}"
      >
        <div class="logo-app">
          <div @click="()=>{this.navigateSite('home')}" class="logo-link">
            <img
                class="logo"
                src="https://storage.googleapis.com/wp-bucket-tcc/channel/images/Logo%20Falkon%20actualizado.png"
                alt="Logo TCC"
            />
          </div>
        </div>

        <v-list color="primary" class="custom-list" id="main-menu">
          <!-- Menu custom -->
          <div :key="i" v-for="(item, i) in routes" 
            :class="optionMenuHide(item)" 
          >
          <!-- v-if="item.url != ''"  -->
            <div 
              v-if="(user.profileComplete && hasClient && user.status == 'ACTIVE' && item.url != '') || (item.name.trim() == 'Editar perfil' || item.name.trim() == 'Cerrar sesión')"
              :class="{'custom-list-group': true, 'inverted':item.inverted, 'exclusive-mobile':item.exclusiveMobile}" 
              @click="(item.url != 'login' ? (event)=>goTo(item.url, event): logout)" 
              :data-active="$route.path.includes(item.url) ? 'true': 'false'"
              :id="item.id"
            >
              <div class="custom-image-list">
                <img class="custom-icon-route" :src="item.icon" />
                <img class="custom-icon-route-active" :src="item.icon_active"  />
                <div class="custom-icon-expand">
                  <v-icon class="custom-icon"
                          size="18"
                          color="white">
                    mdi-chevron-down
                  </v-icon>
                </div>
              </div>
              <span class="custom-title-item-list">
                {{ item.name }}
              </span>
              <span class="ripple" @animationend="(event)=>rippleEnd(event)" data-anim="false"> </span>
            </div>
            <div v-else-if="user.profileComplete && hasClient && user.status == 'ACTIVE'" class="custom-list-group-with-subgroup" :id="item.id">
              <div class="custom-list-group" @click="(event)=>openGroup(i, event)" :class="item.notify && (getNotifications(item.notifyName) && getNotifications(item.notifyName).length > 0) ? 'with-notifications': ''">
                <div class="custom-image-list">
                  <img class="custom-icon-route" :src="item.icon" />
                  <img class="custom-icon-route-active" :src="item.icon_active"  />
                  <div class="custom-icon-expand">
                    <v-icon class="custom-icon"
                            size="18"
                            color="white">
                      mdi-chevron-down
                    </v-icon>
                  </div>
                </div>
                <span class="custom-title-item-list">
                  {{ item.name }}
                  <span class="flag-new" v-if="item.name == 'Pago contra entrega' && showFlagNewRecollected" >¡Nuevo!</span>

                  <!-- Notifications Module -->
                  <NotificationsMenu 
                    v-if="item.notify && (getNotifications(item.notifyName) && getNotifications(item.notifyName).length > 0)" 
                    :optionMenu="item"
                    :notifications="getNotifications(item.notifyName)"
                  />
                  <!-- End Notifications Module -->
                  
                </span>
                <span class="ripple" @animationend="(event)=>rippleEnd(event)" data-anim="false"> </span>
              </div>
              <ul class="custom-list-subgroup" :data-groupid="i">
                <li :key="i" v-for="(subRoute, i) in item.subRoutes" @click="(event)=>goTo(subRoute.url, event)">
                  {{ subRoute.name }}
                  <span class="ripple" @animationend="(event)=>rippleEnd(event)" data-anim="false"> </span>
                </li>
              </ul>
            </div>
          </div>
          <!-- end menu custom -->

        </v-list>
      </v-navigation-drawer>

      <v-main class="fill-height" :style="{'padding': paddingMain}" >
        <div style="display:flex; flex-direction:column; min-height:100%">
        <nav class="app-nav justify-space-between" :class="{'justify-end': !user.profileComplete}" id="tiempos-entrega">
          <div class="row-options only-desk" id="menu-superior">
            <div class="option-custom-menu">
              <a href="/tiempos-de-entrega">
                Tiempos de entrega
              </a>
            </div>
            <div class="option-custom-menu">
              <a href="/contacto">
                Contacto
              </a>
            </div>
            <div class="option-custom-menu">
              <a href="/tutorial">
                ¿Como usar Falkon?
              </a>
            </div>
            <div class="option-custom-menu">
              <a href="/preguntas-frecuentes">
                Preguntas frecuentes
              </a>
            </div>
          </div>

          <section class="d-flex d-lg-none">
            <a href="/home" class="logo-link">
              <img
                class="logo"
                src="https://storage.googleapis.com/wp-bucket-tcc/channel/images/LogoFalkon4_byTcc.png"
                alt="Logo TCC"
              />
            </a>
          </section>

          <section class="logo-container d-flex d-lg-none " v-if="user.profileComplete">
            <NewsPanel />
            <img src="https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/iconmenu.svg"
              @click="drawer = !drawer">
          </section>

          <div class="d-none d-lg-flex" id="profile-menu">
            <UserMenu id="profile-menu"/>
            <NewsPanel ref="newspanel" @closeMenuProfile="closeMenuProfile" :isSubMenuActive="isSubMenuActive"/>
          </div>
        </nav>
        <div style="flex-grow:1; background: #F8F8F8;" :class="[$route.name === 'home' ? 'home-background' : '']" >
          <router-view styel="min-height:100%; height:100%" />
        </div>
        </div>
      </v-main>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import jwtService from "@/services/jwt";
import TermsDialog from "@/components/Login/TermsDialog.vue";
import NotificationsMenu from "./components/NotificationsMenu/NotificationsMenu.vue";
import NewsPanel from "./components/NewsPanel/NewsPanel.vue";
import TourService from "@/services/tourService";
import { mainMenuTour, mainMenuTourMeta } from "./OB-AppTemplate";
import UserMenu from "@/components/configuration/UserMenu.vue";

export default {
  components: { TermsDialog, NotificationsMenu, NewsPanel, UserMenu },
  mounted() {
    this.onResize(),
    this.periodicVaidation(),
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
    this.ValidateTermsAndDataPolicy();  //valida si el usuario acepto terminos y condiciones
    this.adjustedRoutes();
    const currentDate = new Date();
    const startDate = new Date('2024-09-20T00:01:00');
    const endDate = new Date('2024-10-31');

    // valiamos la flag para que sea del 20 de septiembre al 31 de octubre del 2024
    if (currentDate >= startDate && currentDate <= endDate) {
      this.showFlagNewRecollected = true;
    } else {
      this.showFlagNewRecollected = false;
    }
    
    this.initNotifications();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);

    // Cerramos la conexión cuando se destruya el componente
    if (this.eventSource) {
      this.eventSource.close();
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.userProfile.userProfile,
      isLoggedIn: (state) => state.auth.isLoggedIn,
      isAdmin: (state)=> state.userProfile.userProfile.isAdmin,
      hasClient: (state)=> state.userProfile.userProfile.client,
      auth: (state)=> state.auth
    }),
    isProfileReady() {
      return !!(this.user?.profileComplete && this.hasClient && this.user?.status === 'ACTIVE')
    },
  },
  /*
    revisar si el menu lo quieren invertido
    tambien los iconos blanco y negro se deben poner invertidos
  */
  data: () => ({
    _onboardingStarted: false,
    drawer: true,
    isSubMenuActive: false,
    isSmall: false,
    menuConditionRecaudos: 0,
    routes: [
      {
        name: "¿Cómo usar falkon?",
        url: "tutorial",
        icon: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/play-circle-white.svg",
        icon_active: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/play-circle-black.svg",
        subRoutes: [],
        submenu: false,
        inverted: false,
        exclusiveMobile: true,
        id: "",
        notify: false,
        notifyName: []
      },
      {
        name: "Rastrear",
        url: "rastreo",
        icon: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/iconmenu1.svg",
        icon_active: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/iconmenu1active.svg",
        subRoutes: [],
        submenu: false,
        inverted: false,
        exclusiveMobile: false,
        id: "rastreo",
        notify: false,
        notifyName: []
      },
      {
        name: "Cotizar",
        url: "",
        icon: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/iconmenu2.svg",
        icon_active: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/iconmenu2active.svg",
        subRoutes: [
          { name: "Cotizar envío", url: "cotizar" },
          { name: "Consulto estimación envíos", url: "estimacionenvios" }
        ],
        submenu: true,
        inverted: false,
        exclusiveMobile: false,
        id: "cotizar",
        notify: false,
        notifyName: []
      },
      {
        name: "Envíos",
        url: "",
        icon: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/iconmenu3.svg",
        icon_active: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/iconmenu3active.svg",
        subRoutes: [
          { name: "Crear envío", url: "logisticainversa" },
          { name: "Cancelar envío", url: "anulaciones" },
          { name: "Consultar recogida", url: "consultasolicitudrecogida" }
        ],
        submenu: true,
        inverted: false,
        exclusiveMobile: false,
        id: "generar-guia",
        notify: true,
        notifyName: ['Recogidas']
      },
      {
        name: "Mis etiquetas y despachos",
        url: "rotulosdespacho",
        icon: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/iconorotulos.png",
        icon_active: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/iconorotulosactivo.svg",
        subRoutes: [],
        submenu: false,
        inverted: false,
        exclusiveMobile: false,
        id: "rotulosdespacho",
        notify: false,
        notifyName: []
      },
      {
        name: "Pago contra entrega",
        url: "",
        icon: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/recaudos.svg",
        icon_active: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/recaudosactive.svg",
        subRoutes: [],
        submenu: true,
        inverted: false,
        exclusiveMobile: false,
        id: "recaudo",
        notify: true,
        notifyName: ['Recaudos', 'RecaudosIni']
      },
      {
        name: "Mis novedades",
        url: "",
        icon: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/iconmenu5.svg",
        icon_active: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/iconmenu5active.svg",
        subRoutes: [
          { name: "Gestión de novedades", url: "novedades" },
          { name: "Inscripción de novedades", url: "gestionnovedades" },
        ],
        submenu: true,
        inverted: false,
        exclusiveMobile: false,
        id: "novedades",
        notify: true,
        notifyName: ['Novedades']
      },
      {
        name: "Crédito",
        url: "",
        icon: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/noun-money-white.svg",
        icon_active: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/noun-money-black.svg",
        subRoutes: [
          { name: "Mis facturas", url: "mis-facturas" },
          //{ name: "Inscripcion", url: "inscripcion-facturas" },
        ],
        submenu: false,
        inverted: false,
        exclusiveMobile: false,
        id: "credito",
        notify: true,
        notifyName: ['Facturas']
      },
      {
        name: "Mis indicadores",
        url: "",
        icon: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/iconmenu4.svg",
        icon_active: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/iconmenu4active.svg",
        subRoutes: [
          { name: "Indicadores de entrega", url: "indicadores" },
          { name: "Indicadores de recogida", url: "recogidas" },
          { name: "Indicadores de rastreo", url: "informerastreo" },
          // { name: "Tablero de reofrecimiento", url: "reofrecimientos" },
        ],
        submenu: true,
        inverted: false,
        exclusiveMobile: false,
        id: "indicadores",
        notify: false,
        notifyName: []
      },
      {
        name: "Tiempos de entrega",
        url: "tiempos-de-entrega",
        icon: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/icontiempos-white.svg",
        icon_active: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/icontiempos-black.svg",
        subRoutes: [],
        submenu: false,
        inverted: false,
        exclusiveMobile: true,
        id: "",
        notify: false,
        notifyName: []
      },
      {
        name: "Contáctanos",
        url: "contacto",
        icon: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/iconcontact.png",
        icon_active: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/iconcontactactive.png",
        subRoutes: [],
        submenu: false,
        inverted: false,
        exclusiveMobile: true,
        id: "",
        notify: false,
        notifyName: []
      },
      {
        name: "Preguntas frecuentes",
        url: "preguntas-frecuentes",
        icon: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/question-circle-white.svg",
        icon_active: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/question-circle-black.svg",
        subRoutes: [],
        submenu: false,
        inverted: false,
        exclusiveMobile: true,
        id: "",
        notify: false,
        notifyName: []
      },
      {
        name: "Editar perfil",
        url: "profile",
        icon: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/profile-black.svg",
        icon_active: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/profile-white.svg",
        subRoutes: [],
        submenu: false,
        inverted: true,
        exclusiveMobile: true,
        id: "",
        notify: false,
        notifyName: []
      },
      {
        name: "Gestión de usuarios",
        url: "administracion-usuarios",
        icon: "https://fonts.gstatic.com/s/i/materialiconsoutlined/group/v1/24px.svg",
        icon_active: "https://fonts.gstatic.com/s/i/materialicons/group/v1/24px.svg",
        subRoutes: [],
        submenu: false,
        inverted: true,
        exclusiveMobile: true,
        id: "administrar",
        notify: false,
        notifyName: []
      },
      {
        name: "Configuración",
        url: "configuration",
        icon: "https://fonts.gstatic.com/s/i/materialiconsoutlined/settings/v1/24px.svg",
        icon_active: "https://fonts.gstatic.com/s/i/materialicons/settings/v1/24px.svg",
        subRoutes: [],
        submenu: false,
        inverted: true,
        exclusiveMobile: true,
        id: "",
        notify: false,
        notifyName: []
      },
      {
        name: "Cerrar sesión",
        url: "login",
        icon: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/logout-black.svg",
        icon_active: "https://storage.googleapis.com/wp-bucket-tcc/channel/images/menu/logout-white.svg",
        subRoutes: [],
        submenu: false,
        inverted: true,
        exclusiveMobile: true,
        id: ""
      }
    ],
    windowWidth: window.innerWidth,
    paddingMain: "0 0 0 0",
    menuWidth: "0",
    showTermsModal: false,
    menuProtected: ['Administracion de usuarios', 'Pago contra entrega', 'Crédito'],
    showFlagNewRecollected: false,
    showingTour: false,
    notificationsArray: [],
    eventSource: null,
  }),
  methods: {
    ...mapActions('news', [
      'initNews',
      'addNews',
      'removeNewsByIdWp'
    ]),
    async adjustedRoutes() {
      await this.updateRecaudo();
      return this.routes.map(route => {
        if (route.name === "Pago contra entrega") {
          route.subRoutes = this.menuConditionRecaudos === 0
            ? [{ name: "Activar pago contra entrega", url: "inscripcionrecaudo" }]
            : [{ name: "Activar pago contra entrega", url: "inscripcionrecaudo" },{ name: "Seguimiento de pagos", url: "mispagos" }];
        }
        return route;
      });
    },
    async updateRecaudo(){
      const userTrim = JSON.parse(JSON.stringify(this.user).replace(/"\s+|\s+"/g,'"'));
      if(userTrim && userTrim.userCollected){
        this.menuConditionRecaudos = 1
      }
    },
    profile() {
      if (this.$route.name !== "profile") {
        this.$router.push({ name: "profile" });
      }
      this.isSubMenuActive = false
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push({ name: "login" });
      this.$emit("logout");
    },
    goTo(url, e){
      this.navigateSite(url)

      //ripple animation
      let ripple = e.currentTarget.querySelector(".ripple");
      ripple.dataset.anim = "true";
    },
    navigateSite(url){
      if(url === "contacto1"){
        let urlContact = "https://dev.smk.agency/falkon/contactanos/"
        window.open(urlContact, '_blank').focus();
      } else{
        if (this.$route.name !== url) {
          this.$router.push({ name: url });
        }
      }
    },
    hoverMouse(event){
      let elementList = event.target
      let elementAcordion = elementList.querySelector(".icon-wave")
      elementAcordion.setAttribute('src', 'https://storage.googleapis.com/wp-bucket-tcc/channel/images/home/menuaccordiongreen.svg')
      //console.log(elementAcordion)
    },
    async periodicVaidation () {
      const min = 30
      const timeInterval = min * 60 * 1000; // en milisegundos
      //console.log("🚀 ~ file: AppTemplate.vue:265 ~ periodicalVaidation -> time:", (min), 'min' )
      async function  consultarServicio() {
        const tokenValidation = await jwtService.validateToken()
        if ( !tokenValidation ){
          this.$router.push('/login')
        }
      }
      setInterval(consultarServicio, timeInterval);
      // const intervalId = setInterval(consultarServicio, mediaHora);
      // setTimeout(() => clearInterval(intervalId), 10 * mediaHora);
    },
    onResize() {
      // Init value
      this.windowWidth = window.innerWidth;
      this.paddingMain = "0 0 0 0";

      if(this.windowWidth < 1264 ){
        this.paddingMain = "0 0 0 0";
        this.menuWidth = "330px";
      } else if(this.windowWidth > 1264 && (!this.user.profileComplete || !this.hasClient || this.user.status != 'ACTIVE') ){
        this.paddingMain = "0 0 0 0";
        this.menuWidth = "0";
      } else if(this.windowWidth <= 1366 && this.user.profileComplete && this.hasClient && this.user.status == 'ACTIVE'){
        this.paddingMain = "0 0 0 253px";
        this.menuWidth = "253px";
      }
      else if(this.windowWidth > 1366 && this.user.profileComplete && this.hasClient && this.user.status == 'ACTIVE') {
        this.paddingMain = "0 0 0 349px";
        this.menuWidth = "349px";
      }
    },
    openGroup(groupId, e){
      let groups = document.getElementsByClassName('custom-list-subgroup');

      let exceptions = ['custom-list-group', 'custom-icon-route-active', 'custom-title-item-list'];
      if(exceptions.some(exeption => e.target.classList.contains(exeption))){
        groups.forEach(group => {
          if(group.dataset.groupid == groupId){
            group.classList.toggle('open');
          }
          else {
            group.classList.remove('open')
          }
        });
  
        //ripple animation
        let ripple = e.currentTarget.querySelector(".ripple");
        ripple.dataset.anim = "true";
      }
    },
    rippleEnd: function(event) {
      event.target.dataset.anim = "false";
		},
    ValidateTermsAndDataPolicy(){
      if(!this.user.acceptDataPolicyTreatment && !this.user.acceptTermsAndConditions){
        this.showTermsModal = true;
      }
    },
    optionMenuHide(item){
      if(!this.isAdmin){
        if(this.menuProtected.find(option => option == item.name)){
          return 'custom-container-menu-list hidden';
        }
        else {
          return 'custom-container-menu-list';
        }
      }
      else {
        if(!this.user.client?.creditoCorto && item.name == 'Crédito'){
          return 'custom-container-menu-list hidden';
        }
        
        return 'custom-container-menu-list';
      }
    },
    async showOnboarding(){
      // Configura el token y sincroniza el estado de tours desde el backend
      // (solo ocurre una vez por sesión; usa localStorage como caché)
      TourService.setToken(this.auth.token)
      await TourService.syncFromBackend()

      let steps = mainMenuTour
      const forbidden = ['recaudo', 'administrar'];
      await this.$nextTick(()=>{
        if(!this.isAdmin){
          steps = steps.filter(item => !forbidden.some(word => item.name.includes(word)))
        }
        if(!this.user.client?.creditoCorto){
          steps = steps.filter(item => item.name != "credito")
        }

        setTimeout(() => {
          TourService.start({
            tourName: 'tutorial_mainmenu',
            steps,
            releaseDate: mainMenuTourMeta.releaseDate,
            showTo: mainMenuTourMeta.showTo,
            onCloseCallback: ()=>{
              this.showingTour = false
            }
          })
          this.showingTour = TourService?.getStateTour()
        }, 500);
      }) // 🧱 DOM listo
    },
    initNotifications() {
      this.eventSource = this.$notificationsService.connect(
        this.auth.token,
        (data) => {
          if (data.type === 'init') {
            this.notificationsArray = data.notifications;
            // Inicializar noticias desde el store
            this.initNews(data.news || [])
          } 
          else if(data.type === 'news') {
            // Agregar nueva noticia al store
            this.addNews(data.news)
            //aqui poner la animacion de la campana con cada noticia que llegue
          }
          else if(data.type === 'news_deleted'){
            // Eliminar noticia del store
            this.removeNewsByIdWp(data.id_wp)
          }
          else {
            // Insertamos la nueva notificación al inicio del array
            this.notificationsArray.unshift(data);
          }
        },
        (error) => {
          console.error('❌ Error en notificaciones:', error);
        }
      );
    },
    getNotifications(groupName) {
      let notiFilter = this.notificationsArray.filter(notify => groupName.some(name => name?.toUpperCase() === notify?.data?.type.toUpperCase()))
      if(notiFilter.length > 0){
        return notiFilter
      }
    },
    updateNotifications (id) {
      this.notificationsArray = this.notificationsArray.filter(notify => notify.id != id)
    },
    activateAnimationBell(element){
      element.classList.remove('animated')
      setTimeout(() => {
        element.classList.add('animated')
      }, 200);
    },
    openMenuProfile(){
      this.isSubMenuActive = !this.isSubMenuActive
      if(this.isSubMenuActive){
        document.documentElement.classList.add('modal-open');
      }
      if(!this.isSubMenuActive && !this.$refs.newspanel.openNews){
        document.documentElement.classList.remove('modal-open');
      }
      if(this.$refs.newspanel.openNews){
        this.$refs.newspanel.toggleMenuNews()
      }
    },
    closeMenuProfile(){
      // para cerrar el menu profile desde el click en newspanel
      this.isSubMenuActive = false
    }
  },
  watch: {
    isProfileReady: {
      immediate: true,
      handler(ready) {
        if (ready && !this._onboardingStarted) {
          this._onboardingStarted = true
          this.showOnboarding()
        }
      }
    },
    user: {
      handler(/* nuevoValor, valorAnterior */) {
        //console.log('registered:', nuevoValor);  // eslint-disable-line
        //console.log('lastvalue:', valorAnterior);  // eslint-disable-line
        this.onResize();
      },
      deep: true
    },
    isAdmin: {
      handler() {
        let urlToprotect = ['/administracion-usuarios', '/inscripcionrecaudo', '/mispagos'];
        if(!this.isAdmin && urlToprotect.some(url => url == this.$router.history.current.fullPath)){
          this.$router.push('/home');
        }
      }
    }
  },
  provide () {
    return {
      clientDocumentNumber: this.hasClient?.documentNumber,
      updateNotifications: this.updateNotifications
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./scss/menu/styles";
@import "./scss/menu/custom-menu";

.flag-new{
  background: #5ddead;
  position: absolute;
  color: black;
  padding: 5px;
  right: 10px;
  border-radius: 5px;
  top: 50%;
  transform: translateY(-50%);
}
.app-nav {
  .only-desk {
    @media screen and (max-width: 1080px){
      display: none;
    }
  }
}

.row-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
  height: 100%;
  align-content: center;

  .option-custom-menu {
    position: relative;
  }
}

.logo-app {
  .notifications {
    position: absolute;
  }
}
</style>